export default __webpack_public_path__ + "static/media/menu_toggle_icon.78275fff.svg";